"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingClient = void 0;
const _ = __importStar(require("./utils"));
const tracking_events_1 = require("@sparefoot/tracking-events");
const errors_1 = require("./errors");
class TrackingClient {
    /**
     * Creates a new instance of the TrackingClient.
     * @param tracker - The tracking implementation to use.
     */
    constructor(tracker) {
        this.getUrlProperties = () => {
            if (!location || !document) {
                throw new errors_1.TrackingClientError(errors_1.ErrorMessage.NO_URL);
            }
            const url = location.href;
            const search = new URLSearchParams(location.search);
            const path = location.pathname;
            const referrer = document.referrer;
            // Check if the referrer is provided; if not, use a fallback (empty string)
            let referrerPath = '';
            if (referrer) {
                try {
                    referrerPath = new URL(referrer).pathname;
                }
                catch (error) {
                    // If an error occurs, fall back to an empty string
                    referrerPath = '';
                }
            }
            const [pagePathLevel1, pagePathLevel2, pagePathLevel3] = location.pathname.split("/").slice(1);
            const pageSearch = search.toString();
            const pageHash = location.hash;
            const pageHostname = location.hostname;
            const title = document.title;
            const utmProperties = Object.keys(tracking_events_1.UtmParamQueryKeys).reduce((acc, param) => {
                const value = search.get(tracking_events_1.UtmParamQueryKeys[param]);
                if (value) {
                    acc[param] = value;
                }
                return acc;
            }, {});
            return {
                // URL Properties
                [tracking_events_1.TrackingPropertyKey.PATH]: path,
                [tracking_events_1.TrackingPropertyKey.REFERRER]: referrer,
                [tracking_events_1.TrackingPropertyKey.PAGE_TITLE]: title,
                [tracking_events_1.TrackingPropertyKey.URL]: url,
                [tracking_events_1.TrackingPropertyKey.REFERRER_PATH]: referrerPath,
                [tracking_events_1.TrackingPropertyKey.PAGE_PATH_LEVEL_1]: pagePathLevel1,
                [tracking_events_1.TrackingPropertyKey.PAGE_PATH_LEVEL_2]: pagePathLevel2,
                [tracking_events_1.TrackingPropertyKey.PAGE_PATH_LEVEL_3]: pagePathLevel3,
                [tracking_events_1.TrackingPropertyKey.PAGE_SEARCH]: pageSearch,
                [tracking_events_1.TrackingPropertyKey.PAGE_HASH]: pageHash,
                [tracking_events_1.TrackingPropertyKey.PAGE_HOSTNAME]: pageHostname,
                // UTM Properties
                [tracking_events_1.TrackingPropertyKey.UTM_SOURCE]: utmProperties[tracking_events_1.UtmParamQueryKeys.UTM_SOURCE],
                [tracking_events_1.TrackingPropertyKey.UTM_MEDIUM]: utmProperties[tracking_events_1.UtmParamQueryKeys.UTM_MEDIUM],
                [tracking_events_1.TrackingPropertyKey.UTM_CAMPAIGN]: utmProperties[tracking_events_1.UtmParamQueryKeys.UTM_CAMPAIGN],
                [tracking_events_1.TrackingPropertyKey.UTM_CONTENT]: utmProperties[tracking_events_1.UtmParamQueryKeys.UTM_CONTENT],
                [tracking_events_1.TrackingPropertyKey.UTM_TERM]: utmProperties[tracking_events_1.UtmParamQueryKeys.UTM_TERM],
                [tracking_events_1.TrackingPropertyKey.UTM_KEYWORD]: utmProperties[tracking_events_1.UtmParamQueryKeys.UTM_KEYWORD],
                [tracking_events_1.TrackingPropertyKey.UTM_ADGROUP]: utmProperties[tracking_events_1.UtmParamQueryKeys.UTM_ADGROUP],
                [tracking_events_1.TrackingPropertyKey.GCLID]: utmProperties[tracking_events_1.UtmParamQueryKeys.GCLID],
            };
        };
        /**
         * Tracks a page view.
         * @param p - The properties to track.
         */
        this.trackPageView = (p) => {
            // Rest used to keep utm properties as an object for ReactSegmentWrapper
            const { page_type, page_name } = p;
            const urlUtmProperties = this.getUrlProperties();
            this.tracker.identify(_.pick(urlUtmProperties, [
                tracking_events_1.TrackingPropertyKey.UTM_SOURCE,
                tracking_events_1.TrackingPropertyKey.UTM_MEDIUM,
                tracking_events_1.TrackingPropertyKey.UTM_CAMPAIGN,
                tracking_events_1.TrackingPropertyKey.UTM_CONTENT,
                tracking_events_1.TrackingPropertyKey.UTM_TERM,
                tracking_events_1.TrackingPropertyKey.UTM_KEYWORD,
                tracking_events_1.TrackingPropertyKey.UTM_ADGROUP,
                tracking_events_1.TrackingPropertyKey.GCLID,
            ]));
            this.tracker.pageView(page_type, page_name, {
                ...urlUtmProperties,
            });
        };
        /**
         * Tracks an experiment view.
         * @param p - The properties to track.
         */
        this.trackExperimentView = (p) => {
            // verbose destructuring
            const { category, label, experiment_source, experiment_id, variant_id } = p;
            this.tracker.track(tracking_events_1.EventNames.EXPERIMENT_VIEWED, {
                category,
                label,
                experiment_source,
                experiment_id,
                variant_id,
            });
        };
        /**
         * Tracks a CTA click.
         * @param p - The properties to track.
         */
        this.trackCTAClick = (p) => {
            this.tracker.track(tracking_events_1.EventNames.CTA_CLICKED, p);
        };
        /**
         * Tracks a search submitted.
         * @param p - The properties to track.
         */
        this.trackSearchSubmitted = (p) => {
            this.tracker.track(tracking_events_1.EventNames.SEARCH_SUBMITTED, p);
        };
        /**
         * Tracks a search filtered.
         * @param p - The properties to track.
         */
        this.trackSearchFiltered = (p) => {
            this.tracker.track(tracking_events_1.EventNames.SEARCH_FILTERED, p);
        };
        /**
         * Tracks a facility list viewed.
         * @param p - The properties to track.
         */
        this.trackFacilityListViewed = (p) => {
            this.tracker.track(tracking_events_1.EventNames.FACILITY_LIST_VIEWED, p);
        };
        /**
         * Tracks a facility viewed.
         * @param p - The properties to track.
         */
        this.trackFacilityViewed = (p) => {
            this.tracker.track(tracking_events_1.EventNames.FACILITY_VIEWED, p);
        };
        /**
         * Tracks a facility unit selected.
         * @param p - The properties to track.
         */
        this.trackFacilityUnitSelected = (p) => {
            this.tracker.track(tracking_events_1.EventNames.FACILITY_UNIT_SELECTED, p);
        };
        /**
         * Tracks a reservation started.
         * @param p - The properties to track.
         */
        this.trackReservationStarted = (p) => {
            this.tracker.track(tracking_events_1.EventNames.RESERVATION_STARTED, p);
        };
        /**
         * Tracks a reservation completed.
         * @param p - The properties to track.
         */
        this.trackReservationCompleted = (p) => {
            this.tracker.track(tracking_events_1.EventNames.RESERVATION_COMPLETED, p);
        };
        /**
         * Tracks a online move in started.
         * @param p - The properties to track.
         */
        this.trackOnlineMoveInStarted = (p) => {
            this.tracker.track(tracking_events_1.EventNames.ONLINE_MOVE_IN_STARTED, p);
        };
        /**
         * Tracks a online move in step viewed.
         * @param p - The properties to track.
         */
        this.trackOnlineMoveInStepViewed = (p) => {
            this.tracker.track(tracking_events_1.EventNames.ONLINE_MOVE_IN_STEP_VIEWED, p);
        };
        /**
         * Tracks a online move in completed.
         * @param p - The properties to track.
         */
        this.trackOnlineMoveInCompleted = (p) => {
            this.tracker.track(tracking_events_1.EventNames.ONLINE_MOVE_IN_COMPLETED, p);
        };
        /**
         * Tracks a form submitted.
         * @param p - The properties to track.
         */
        this.trackFormSubmitted = (p) => {
            this.tracker.identify(_.pick(p, [
                tracking_events_1.TrackingPropertyKey.EMAIL,
                tracking_events_1.TrackingPropertyKey.PHONE,
                tracking_events_1.TrackingPropertyKey.FIRST_NAME,
                tracking_events_1.TrackingPropertyKey.LAST_NAME,
            ]));
            this.tracker.track(tracking_events_1.EventNames.FORM_SUBMITTED, p);
        };
        /**
         * Tracks a contact link clicked.
         * @param p - The properties to track.
         */
        this.trackContactLinkClicked = (p) => {
            this.tracker.track(tracking_events_1.EventNames.CONTACT_LINK_CLICKED, p);
        };
        /**
         * Tracks a outbound link clicked.
         * @param p - The properties to track.
         */
        this.trackOutboundLinkClicked = (p) => {
            this.tracker.track(tracking_events_1.EventNames.OUTBOUND_LINK_CLICKED, p);
        };
        /**
         * Tracks a video watched.
         * @param p - The properties to track.
         */
        this.trackVideoWatched = (p) => {
            this.tracker.track(tracking_events_1.EventNames.VIDEO_WATCHED, p);
        };
        /**
         * Tracks a facility move in confirmed.
         * @param p - The properties to track.
         */
        this.trackFacilityMoveInConfirmed = (p) => {
            this.tracker.track(tracking_events_1.EventNames.FACILITY_MOVE_IN_CONFIRMED, p);
        };
        this.tracker = tracker;
    }
    /**
     * Returns the singleton instance of the TrackingClient.
     * @returns The singleton instance of the TrackingClient.
     */
    static getInstance() {
        if (!TrackingClient.instance) {
            throw new errors_1.TrackingClientError(errors_1.ErrorMessage.NOT_INITIALIZED);
        }
        return TrackingClient.instance;
    }
    /**
     * Initializes the TrackingClient.
     * @param tracker - The tracking implementation to use.
     * @returns The singleton instance of the TrackingClient.
     */
    static initialize(tracker) {
        if (!tracker) {
            throw new errors_1.TrackingClientError(errors_1.ErrorMessage.NO_TRACKER);
        }
        if (TrackingClient.instance) {
            throw new errors_1.TrackingClientError(errors_1.ErrorMessage.ALREADY_INITIALIZED);
        }
        return (TrackingClient.instance = new TrackingClient(tracker));
    }
    /**
     * Creates a static method that can be used to call a client convenience method
     * without having to have an instance of the TrackingClient.
     *
     * @param methodName - The name of the client convenience method to create a static method for.
     * @returns A static method that can be used to call the client convenience method without having to have an instance of the TrackingClient.
     */
    static createStaticTracker(methodName) {
        return (props) => {
            const instance = TrackingClient.getInstance();
            return instance[methodName](props);
        };
    }
    /**
     * Resets the TrackingClient instance.
     * Primarily used for testing purposes.
     */
    static reset() {
        TrackingClient.instance = null;
    }
}
exports.TrackingClient = TrackingClient;
TrackingClient.instance = null;
TrackingClient.trackPageView = TrackingClient.createStaticTracker("trackPageView");
TrackingClient.trackExperimentView = TrackingClient.createStaticTracker("trackExperimentView");
TrackingClient.trackCTAClick = TrackingClient.createStaticTracker("trackCTAClick");
TrackingClient.trackSearchSubmitted = TrackingClient.createStaticTracker("trackSearchSubmitted");
TrackingClient.trackSearchFiltered = TrackingClient.createStaticTracker("trackSearchFiltered");
TrackingClient.trackFacilityListViewed = TrackingClient.createStaticTracker("trackFacilityListViewed");
TrackingClient.trackFacilityViewed = TrackingClient.createStaticTracker("trackFacilityViewed");
TrackingClient.trackFacilityUnitSelected = TrackingClient.createStaticTracker("trackFacilityUnitSelected");
TrackingClient.trackReservationStarted = TrackingClient.createStaticTracker("trackReservationStarted");
TrackingClient.trackReservationCompleted = TrackingClient.createStaticTracker("trackReservationCompleted");
TrackingClient.trackOnlineMoveInStarted = TrackingClient.createStaticTracker("trackOnlineMoveInStarted");
TrackingClient.trackOnlineMoveInStepViewed = TrackingClient.createStaticTracker("trackOnlineMoveInStepViewed");
TrackingClient.trackOnlineMoveInCompleted = TrackingClient.createStaticTracker("trackOnlineMoveInCompleted");
TrackingClient.trackFormSubmitted = TrackingClient.createStaticTracker("trackFormSubmitted");
TrackingClient.trackContactLinkClicked = TrackingClient.createStaticTracker("trackContactLinkClicked");
TrackingClient.trackOutboundLinkClicked = TrackingClient.createStaticTracker("trackOutboundLinkClicked");
TrackingClient.trackVideoWatched = TrackingClient.createStaticTracker("trackVideoWatched");
TrackingClient.trackFacilityMoveInConfirmed = TrackingClient.createStaticTracker("trackFacilityMoveInConfirmed");
//# sourceMappingURL=TrackingClient.js.map